module.exports = __webpack_public_path__ + "static/media/transparency.6d269736.svg";